export default {
  page: {
    title: 'Configuraciones',
    subtitle: 'Sistema',
  },
  tabs: {
    company: 'Datos de la empresa',
    messages: 'Textos de los impresos',
    settings: 'Variables del sistema',
    accessControl: 'Control de acceso',
  },
  accessControl: {
    tabs: {
      roles: 'Tipos',
      modules: 'Módulos',
      users: 'Usuarios',
    },
  },
  company: {
    form: {
      name: {
        label: 'Nombre',
        placeholder: 'Nombre',
      },
      bgColor: {
        label: 'Color de fondo',
        hint: 'pdf',
        placeholder: 'Fondo',
      },
      fontColor: {
        label: 'Color de fuente (estándar)',
        hint: 'pdf',
        placeholder: 'Fuente',
      },
      fontColor2: {
        label: 'Color de fuente',
        hint: 'pdf',
        placeholder: 'Fuente',
      },
      titleColor: {
        label: 'Color del título',
        hint: 'pdf',
        placeholder: 'Fondo',
      },
      cnpj: {
        label: 'CNPJ',
        placeholder: '00.000.000/0000-00',
      },
      email: {
        label: 'Email',
        placeholder: 'E-mail',
      },
      site: {
        label: 'Sitio web',
        placeholder: 'Sitio web',
      },
      instagram: {
        label: 'Instagram',
        placeholder: 'Instagram',
      },
      whatsapp1: {
        label: 'Teléfono 1 Whatsapp',
      },
      whatsapp2: {
        label: 'Teléfono 2 Whatsapp',
      },
      phone: {
        label: 'Teléfono fijo',
        placeholder: 'Teléfono',
      },
      address: {
        label: 'Dirección',
        placeholder: 'Calle, Av, Pasaje',
      },
      number: {
        label: 'Número',
        placeholder: 'Número',
      },
      district: {
        label: 'Barrio',
      },
      city: {
        label: 'Ciudad',
      },
      state: {
        label: 'Estado',
      },
      zipcode: {
        label: 'Código postal',
        placeholder: '00.000-000',
      },
    },
  },
  messages: {
    form: {
      slogan: {
        label: 'Eslogan',
        hint: 'Debajo del nombre de la empresa',
        placeholder: 'Lista debajo del logo en los pdfs',
      },
      receipt: {
        label: 'Mensaje del recibo',
      },
      warranty: {
        label: 'Mensaje de la garantía',
      },
      approbation: {
        label: 'Mensaje de la inspección',
      },
      sendMessage: {
        label: 'Mensaje de envío',
        hintEmail: '(cuerpo del e-mail)',
        hintWhatsapp: '(cuerpo del whatsapp)',
      },
      footer: {
        label: 'Mensaje del pie de página',
      },
    },
  },
  settings: {
    form: {
      warranty: {
        label: 'Tiempo de garantía predeterminado',
        placeholder: 'Año, mes, días',
      },
      timeAlert: {
        label: 'Tiempo de alerta al cliente',
        placeholder: 'Tiempo de espera en días',
      },
      logo: {
        label: 'Logo',
        chooseFile: 'Elija una imagen...',
      },
    },
  },
  roles: {
    card: {
      title: 'Lista de tipos de usuarios',
    },
    placeholder: 'Agregue un nuevo departamento',
  },
  permissions: {
    form: {
      roles: {
        label: 'Tipos de usuario',
      },
    },
    card: {
      title: 'Lista de módulos',
    },
    empty: 'Seleccione un departamento',
    yes: 'Sí',
  },
  users: {
    card: {
      title: 'Lista de usuarios',
    },
    selectRole: 'Seleccione un departamento',
    noContent: 'Ningún usuario registrado aún.',
  },
  alert: {
    companySaved: 'Configuraciones guardadas con éxito',
    messagesSaved: 'Mensajes guardados con éxito',
    settingsSaved: 'Variables guardadas con éxito',
    roleSaved: 'Departamento guardado con éxito',
    roleChanged: 'Departamento modificado con éxito',
    permissionsSaved: 'Permisos guardados con éxito',
  },
};
